<template>
<div id="chengji" class="chengji">
	<div class="titBox">
		<p class="tit">成绩查询</p>
		<div class="titRightBox">
			<ul class="qi" :class="$store.state.qiFocus" @click="qiClick($event)">
				<i class="iconfont">&#xe610;</i>
				<li v-for="(index,i) of qiCount" :key="i" @click.stop="qiClick($event,index)" :class="qiNum==index?'act':''">第{{qiZh(index)}}学期{{qiDang==index?"（当前学期）":""}}</li>
			</ul>
		</div>
	</div>
	<div class="cjBox" v-loading="uinfo_load">
		<ul class="cjList" v-if="xueqiCon.length>0">
			<li v-for="(item,index) in xueqiCon" :key="index">
				<h3>{{item.class_name}}</h3>
				<dl class="info">
					<dd><span>学期总评</span>{{item.score3}}</dd>
					<dd><span>期末成绩</span>{{item.score2}}</dd>
					<dd><span>平时成绩</span>{{item.score1}}</dd>
				</dl>
			</li>
		</ul>
        <div v-else>
            <div class="nodata">
                <img :src="nodataImg">
                <p>待更新</p>
            </div>
        </div>
	</div>
</div>
</template>

<script>
export default {
	name: 'chengji'
	,data () {
		return {
			qiNum:0
			,qiDang:0
			,qiCount:0
			,uinfo_load:false
			,xueqiCon:[]
		}
	}
	,mounted:function(){
		var that=this
			,token=this.$cookies.get("token")
			,serverSrc=that.global.serverSrc
			,qianzui=that.global.qianzui;

		//获取用户数据
		this.$selfjs.getUserCallFn(this,function(res){
			that.qiDang = res.term				//当前学期
			that.qiNum = res.term				//现在选择的学期数
			that.qiCount = res.term_count		//学期数

			that.uinfo_load=false;

			//获取学期列表
			let attach_url = serverSrc + qianzui + "/member/user_result"
			that.$ajax.get(attach_url,{
				params:{
					term:that.qiNum
				}
			})
			.then(function(res){
				let resData=res.data
					// console.log(resData);
				if(resData.code==0){
					that.xueqiCon=resData.data
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
		})
	}
	,methods:{
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//学期是否已开学
		kaixue(i){
			if(this.qiThis>i){
				return '已完成学期'
			}else if(this.qiThis==i){
				return '当前学期'
			}else if(this.qiThis<i){
				return '未开学'
			}
		},
		//学期选择点击
		qiClick(event,num){
			var that=this
			var token=this.$cookies.get("token")
				,serverSrc=that.global.serverSrc
				,qianzui=that.global.qianzui
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				that.qiNum = option.num
				that.loading = true
				
				//获取学期列表
				let attach_url = serverSrc + qianzui + "/member/user_result"
				that.$ajax.get(attach_url,{
					params:{
						term:num
					}
				})
				.then(function(res){
					let resData=res.data
						// console.log(resData);
					if(resData.code==0){
						that.xueqiCon=resData.data
					}else{
						that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
					}
				})
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/chengji.vue